// extracted by mini-css-extract-plugin
export var carrierIcon = "_x2-0";
export var carrierLogo = "_x2-1";
export var detailsSection = "_x2-2";